const customComponentsTypes = {
  layout: "layout",
  masterpage: "masterpage",
  template: "template",
};

const customComponentsTypesOptions = Object.keys(customComponentsTypes).map(el => ({ id: el, name: el }));
export { customComponentsTypes, customComponentsTypesOptions };
